import { StatusBusinessTripFormEnum } from '@/types/enums/business-trip-form-status.enum';
import { t } from '@/utils/lang';
import Chip from '@mui/material/Chip';

export interface StatusChipProps {
    status: StatusBusinessTripFormEnum;
    size?: 'small' | 'medium';
    showChip?: boolean;
    theme?: any;
}

const ChipBusinessTripFormStatus = ({
    status,
    size = 'medium',
    showChip = true,
    theme,
}: StatusChipProps) => {
    let label: string;
    let color:
        | 'info'
        | 'warning'
        | 'success'
        | 'error'
        | 'default'
        | 'primary'
        | 'secondary';
    let colorHex: string;

    switch (status?.toLowerCase()) {
        case StatusBusinessTripFormEnum.NEW.toLowerCase():
        case 'new':
            label = 'Mới';
            color = 'primary';
            colorHex = theme?.palette.primary.main;
            break;
        case StatusBusinessTripFormEnum.ON_TIME.toLowerCase():
        case 'on_time':
            label = 'Đúng giờ';
            color = 'success';
            colorHex = theme?.palette.success.main;

            break;
        case StatusBusinessTripFormEnum.LATE_CHECK_IN.toLowerCase():
        case 'late_check_in':
            label = 'Trễ giờ vào';
            color = 'info';
            colorHex = theme?.palette.info.main;

            break;
        case StatusBusinessTripFormEnum.LATE_CHECK_OUT.toLowerCase():
        case 'late_check_out':
            label = 'Trễ giờ ra';
            color = 'warning';
            colorHex = theme?.palette.warning.main;
            break;
        case StatusBusinessTripFormEnum.LATE_BOTH.toLowerCase():
        case 'late_both':
            label = 'Trễ giờ vào & ra';
            color = 'error';
            colorHex = theme?.palette.error.main;
            break;
        case StatusBusinessTripFormEnum.UNCHECKED_OUT.toLowerCase():
        case 'unchecked_out':
            label = 'Chưa checkout';
            color = 'default';
            colorHex = theme?.palette.secondary.main;
            break;

        default:
            label = 'Chưa xử lý';
            color = 'default';
            colorHex = theme?.palette.text.primary;
    }

    if (showChip) {
        return (
            <Chip
                variant='tonal'
                label={t(label, 'BusinessTripFormStatus')}
                color={color}
                size={size}
            />
        );
    }

    return {
        label: t(label, 'BusinessTripFormStatus'),
        color,
        colorHex,
    };
};

export const getBusinessTripStatusData = (props: StatusChipProps) => {
    return ChipBusinessTripFormStatus(props);
};

export default ChipBusinessTripFormStatus;
